import React from 'react';

const PatientDetails = ({ patient }) => (
  <div className="patient-details">
    <p><strong>Name:</strong> {patient.firstName} {patient.lastName}</p>
    <p><strong>Phone:</strong> {patient.phoneNumber || 'N/A'}</p>
    <p><strong>Email:</strong> {patient.email || 'N/A'}</p>
    <p><strong>Sex:</strong> {patient.sex || 'N/A'}</p>
    <p><strong>DOB:</strong> {patient.dateOfBirth || 'N/A'}</p>
    <p><strong>Age:</strong> {patient.age ?? 'N/A'}</p>
  </div>
);

export default PatientDetails;